import * as React from "react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BreadcrumbLinkProps {
    to?: string;
    isActive?: boolean;
    children?: ReactNode;
}

export const Breadcrumb = (props: any) => (
    <div className="breadcrumb-block clearfix">
        {props.children && <ol className="breadcrumb">{props.children}</ol>}
    </div>
);

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = (props) => {
    if (props.isActive) {
        return <li className="breadcrumb-item active">{props.children}</li>;
    } else if (props.to) {
        return (
            <li className="breadcrumb-item">
                <Link to={props.to}>{props.children}</Link>
            </li>
        );
    } else {
        return <li className="breadcrumb-item">{props.children}</li>;
    }
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./ClientApp/components/common/Breadcrumb.tsx